import { IGlobalState } from '../../../Root/store/appReducer'

export const getForgotPasswordSubmitting = (state: IGlobalState) => state.forgotPassword.submitting
